import ReactDOM from 'react-dom/client';
import './i18n';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { configureStore } from 'redux/store';

// Guard key stored in localStorage to track active authenticated session.
// Removed on tab/browser close so Ctrl+Shift+T restores cannot bypass auth.
const SESSION_GUARD_KEY = '_sg';

const navEntry = performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming;
const isReload = navEntry?.type === 'reload';

if (isReload) {
  // Reload — session is legitimate; restore the guard if session data exists.
  if (sessionStorage.length > 0) {
    localStorage.setItem(SESSION_GUARD_KEY, '1');
  }
} else {
  // Fresh open or Ctrl+Shift+T tab restore.
  const hasGuard = localStorage.getItem(SESSION_GUARD_KEY) === '1';
  if (sessionStorage.length > 0 && !hasGuard) {
    sessionStorage.clear();
  }
}

// On close (or reload): remove the guard so a restored tab cannot reuse the session.
// On reload the guard is restored above after the new page evaluates navigation type.
window.addEventListener('beforeunload', () => {
  localStorage.removeItem(SESSION_GUARD_KEY);
});

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
  <Provider store={configureStore({})}>
    <App />
  </Provider>
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(// console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
